import { Link } from "react-router-dom";
import { BtnContent } from "../components/BtnIcon";
import { IoStorefrontOutline } from "react-icons/io5";

function SareeGuide() {
  return (
    <div className="container py-4 py-md-5" style={{ maxWidth: "720px" }}>
      <h1 className="h3 mb-3">Gift guide</h1>
      <p className="text-muted small mb-4">
        Quick reference for choosing, personalising, and caring for a gift box
        before it reaches someone special.
      </p>

      <section className="mb-4">
        <h2 className="h5 mb-2">How to choose a box</h2>
        <ol className="small ps-3 mb-0">
          <li className="mb-2">Start with the occasion: festive, birthday, wedding, corporate, or thank-you.</li>
          <li className="mb-2">Pick the mood: classic, playful, premium, wellness, gourmet, or keepsake-led.</li>
          <li className="mb-2">Add a personal note, name tag, or brand message for a warmer unboxing.</li>
          <li>Review delivery timing and recipient details before checkout.</li>
        </ol>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Personalisation checklist</h2>
        <p className="small mb-2">
          Share these details in your message when placing a custom order.
        </p>
        <ul className="small ps-3 mb-0">
          <li className="mb-1">
            <strong>Recipient name</strong> - for cards, tags, or box inserts.
          </li>
          <li className="mb-1">
            <strong>Occasion date</strong> - helps us recommend dispatch timing.
          </li>
          <li className="mb-1">
            <strong>Message</strong> - keep it short, warm, and gift-ready.
          </li>
          <li className="mb-1">
            <strong>Preferences</strong> - colors, treats, keepsakes, or items to avoid.
          </li>
          <li>
            <strong>Branding</strong> - logos or corporate notes for team gifting.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Care tips</h2>
        <ul className="small ps-3 mb-0">
          <li className="mb-1">Keep the box flat and away from direct sunlight until gifting.</li>
          <li className="mb-1">Move edible items to cool storage when recommended on the product label.</li>
          <li>Reuse the rigid gift box for keepsakes, cards, photos, or festive decor.</li>
        </ul>
      </section>

      <p className="mb-0">
        <Link to="/shop" className="btn btn-primary btn-sm">
          <BtnContent icon={IoStorefrontOutline}>Shop collection</BtnContent>
        </Link>
      </p>
    </div>
  );
}

export default SareeGuide;
